import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlConstants } from 'src/app/all-modules/shared/constants/api_url_constants';
import { HttpRequestService } from 'src/app/all-modules/shared/services/http-request.service';
import { materialViewModel } from '../../models/material-management/material-model';
import { ShowDateRangeViewModel, showCategoryViewModel, showFileCategoryViewModel, showFileDeleteDTO, showGeneralContractorViewModel, showSOUpdateMoveDates, showTypeViewModel, showVenueCityViewModel, showViewModel, showViewModelForDropdown, showYearViewModel, soListForShowEACFeeUpdateViewModel, soListForShowMoveDateChangesViewModel } from '../../models/show-management/show';
import { stateShortViewModel } from '../../models/state-managment/state.model';
import { cityShortViewModel } from '../../models/city-management/city.model';

@Injectable({
  providedIn: 'root'
})
export class ShowManagementService {

  constructor(private httpRequestService: HttpRequestService) {}
  
  getAllMaterialWithDetails(): Observable<materialViewModel[]> {
    return this.httpRequestService.getData<materialViewModel[]>(ApiUrlConstants.materialGetAllWithDetails);
  }
  getShowCategoryAll(): Observable<showCategoryViewModel[]> {
    return this.httpRequestService.getData<showCategoryViewModel[]>(ApiUrlConstants.getShowCategoryAll);
  }
  getShowTypeAll(): Observable<showTypeViewModel[]> {
    return this.httpRequestService.getData<showTypeViewModel[]>(ApiUrlConstants.getShowTypeAll);
  }
  getShowYearAll(): Observable<showYearViewModel[]> {
    return this.httpRequestService.getData<showYearViewModel[]>(ApiUrlConstants.getShowYearAll);
  }
  getShowVenueAll(): Observable<showVenueCityViewModel[]> {
    return this.httpRequestService.getData<showVenueCityViewModel[]>(ApiUrlConstants.getShowVenueAll);
  }
  getShowDateRangeAll(): Observable<ShowDateRangeViewModel[]> {
    return this.httpRequestService.getData<ShowDateRangeViewModel[]>(ApiUrlConstants.getShowDateRangeAll);
  }
  getShowListAll(): Observable<showViewModel[]> {
    return this.httpRequestService.getData<showViewModel[]>(ApiUrlConstants.getShowListAll);
  }
  getFutureShowListAll(): Observable<showViewModel[]> {
    return this.httpRequestService.getData<showViewModel[]>(ApiUrlConstants.getFutureShowListAll);
  }
  getShowIndustryAll(): Observable<string[]> {
    return this.httpRequestService.getData<string[]>(ApiUrlConstants.getShowIndustryAll);
  }
  getShowFileCategoryAll(): Observable<showFileCategoryViewModel[]> {
    return this.httpRequestService.getData<showFileCategoryViewModel[]>(ApiUrlConstants.getShowFileCategoryAll);
  }
  getAllStates(): Observable<stateShortViewModel[]> {
    return this.httpRequestService.getData<stateShortViewModel[]>(ApiUrlConstants.stateGetAllWithShortDetails);
  }
  getAllCities(): Observable<cityShortViewModel[]> {
    return this.httpRequestService.getData<cityShortViewModel[]>(ApiUrlConstants.cityGetAllWithShortDetails);
  }
  addShow(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.addShow, data);
  }
  getShowGeneralContractorList(): Observable<showGeneralContractorViewModel[]> {
    return this.httpRequestService.getData<any>(ApiUrlConstants.getShowGeneralContractorList);
  }
  getShowById(showId: string): Observable<showViewModel> {
    return this.httpRequestService.getData<showViewModel>(ApiUrlConstants.getShowById+showId,);
  }
  getAllSOByShowIdForEACFee(showId: string): Observable<soListForShowEACFeeUpdateViewModel[]> {
    return this.httpRequestService.getData<soListForShowEACFeeUpdateViewModel[]>(ApiUrlConstants.showByIdSoListForEACFee+showId,);
  }
  getAllSOByShowIdForMoveDateChanges(showId: string): Observable<soListForShowMoveDateChangesViewModel[]> {
    return this.httpRequestService.getData<soListForShowMoveDateChangesViewModel[]>(ApiUrlConstants.showByIdSoListForMoveDateChange+showId,);
  }
  showFileDownload(showFileDocId: string): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.showFileDownload}${showFileDocId}`);
  }
  showFileDelete(showFileDoc: showFileDeleteDTO): Observable<any> {
    return this.httpRequestService.postData<showFileDeleteDTO>(ApiUrlConstants.showFileDelete, showFileDoc);
  }
  updateShow(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.updateShow, data);
  }
  getSamplePDF(): Observable<any> {
    return this.httpRequestService.getFileData(ApiUrlConstants.getSamplePdf);
  }
  cloneShow(data: any): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.cloneShow, data);
  }
  getShowListForDropdown(): Observable<showViewModelForDropdown[]> {
    return this.httpRequestService.getData<showViewModelForDropdown[]>(ApiUrlConstants.getAllShowForDropdownList);
  }
  showUpdateMoveDates(data: showSOUpdateMoveDates): Observable<any> {
    return this.httpRequestService.postData<any>(ApiUrlConstants.showUpdateMoveDates, data);
  }
  downloadCMLayoutExcelFileData(data: any): Observable<any> {
    return this.httpRequestService.postFileData(ApiUrlConstants.jobLaborPlanAllocExcelDataByShowId, data);
  }
}
